module.exports = __webpack_public_path__ + "static/media/header-right.77ba6fcc.png";